import type { ReactNode } from 'react'
import { TrainerCapability } from '@zeus/index'
import { FileDown, Loader, Sheet } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'
import { useCan } from '~/hooks/use-can'

type IProps = {
  onCsv: () => void
  onPdf: () => void
  pdfLoading: boolean
  /** L'analyse des questions, ouverte sur la session. */
  questionsHref: string
  /** Les relevés d'assiduité du parcours (#322), pour l'admin. */
  attendance?: ReactNode
}

/**
 * Exports de la session (#243) : ses résultats en CSV, son rapport PDF, et
 * l'analyse des questions filtrée sur elle. Exporter suit le droit d'exporter
 * les statistiques, comme au tableau de bord ; les relevés d'assiduité, rôle admin.
 */
function SessionExports({ onCsv, onPdf, pdfLoading, questionsHref, attendance }: IProps) {
  const { t } = useTranslation()
  const canExport = useCan(TrainerCapability.STATISTICS_EXPORT)

  return (
    <div className="flex flex-wrap items-center gap-2" {...tourAnchor('sessionDetail.exports')}>
      {canExport && (
        <>
          <Button variant="outline" onClick={onCsv}>
            <Sheet className="mr-2 size-4" aria-hidden="true" />
            {t('sessionDetail.exports.csv')}
          </Button>
          <Button variant="outline" onClick={onPdf} disabled={pdfLoading} aria-busy={pdfLoading}>
            {pdfLoading ? <Loader className="mr-2 size-4 animate-spin" aria-hidden="true" /> : <FileDown className="mr-2 size-4" aria-hidden="true" />}
            {t('sessionDetail.exports.pdf')}
          </Button>
        </>
      )}
      {attendance}
      <Button variant="link" asChild>
        <Link to={questionsHref}>{t('sessionDetail.exports.questions')}</Link>
      </Button>
    </div>
  )
}

export default SessionExports
